import {CommonModule} from '@angular/common';
import {UIRouterModule} from '@uirouter/angular';
import {PrintStates} from './print.states';
import {NgModule} from '@angular/core';
import {PrintRosterComponent} from './print-roster.component';
import { A48PrintReportsModule } from './reports/act48/a48-print-reports.module';
import { QuestionnairePrintReportModule } from './questionnaires/questionnaire-print.module';
import { PrintItemComponent } from './reports/item/print-item.component';
import { PipesModule } from '../pipes/pipes.module';
import { SharedComplianceItemsModule } from '../shared-compliance-items/shared-compliance-items.module';
import { EdlCommonPipesModule } from '@edl-development/edl-common';

@NgModule({
    imports: [
        CommonModule,
        UIRouterModule.forChild({
            states: PrintStates
        }),
        SharedComplianceItemsModule,
        A48PrintReportsModule,
        QuestionnairePrintReportModule,
        EdlCommonPipesModule,
        PipesModule
    ],
    declarations: [
        PrintRosterComponent,
        PrintItemComponent
    ]
})
export class PrintModule { }